import { useState } from 'react';
import { IoIosArrowBack } from 'react-icons/io';
import { Button } from '../ui/button';
import useCoinbaseButton from '@/components/deposit/providers/useCoinbaseButton';
import SelectedDeposit from './SelectedDeposit';
import DepositAmount from '../auth/desktop/DepositAmount';
import usePaymentProvider from '@/hooks/deposit/usePaymentProvider';
import { useIsMobile } from '@/hooks/utilities/use-mobile';
import MobileDepositAmountHeader from './MobileDepositAmountHeader';
import MobileDepositNumberPad from './MobileDepositNumberPad';
import { Icons } from '../shared/icons';
import OnramperUrl from './providers/onRamperUrl';
import moonpayUrl from './providers/moonpayUrl';
export default function DepositMethods() {
  'use no memo';

  const {
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    utilizedProvider
  } = usePaymentProvider();
  const [amountToSend, setAmountToSend] = useState('');
  const handleNumPadChange = (val: string) => {
    if (val?.includes('.')) {
      const parts = val.split('.');
      const integerPart = parts[0];
      let decimalPart = parts[1];
      const decimalLength = decimalPart.length;

      // Limit the decimal part to a maximum of 3 digits
      if (decimalLength > 3) {
        decimalPart = decimalPart.substring(0, 3);
      }
      // Reconstruct the value with the limited decimal part
      val = `${integerPart}.${decimalPart}`;
    }
    setAmountToSend(val);
  };
  const isMobile = useIsMobile();
  const {
    handleOnPress,
    quoteLoading
  } = useCoinbaseButton({
    presetFiatAmount: amountToSend
  });
  const {
    url: urlOnRamper
  } = OnramperUrl({
    amount: amountToSend,
    paymentMethod: selectedPaymentMethod
  });
  const {
    signedUrl: urlMoonpay,
    loading: moonpayLoading
  } = moonpayUrl({
    amount: amountToSend
  });
  const handleClick = async () => {
    if (utilizedProvider == 'Coinbase') {
      await handleOnPress();
    } else if (utilizedProvider == 'Moonpay') {
      window.open(urlMoonpay, '_blank');
    } else if (utilizedProvider == 'OnRamper') {
      window.open(urlOnRamper, '_blank');
    }
  };
  return <>
      <div onClick={() => {
      setSelectedPaymentMethod(null);
    }} className='absolute cursor-pointer left-7 top-7 text-[14px] flex items-center bg-genius-blue rounded-full h-[31px] w-[74px]'>
        <IoIosArrowBack className={`ml-2 mr-2 w-[16px] text-genius-cream`} width={20} height={18} data-sentry-element="IoIosArrowBack" data-sentry-source-file="DepositMethods.tsx" />{' '}
        <p>Back</p>
      </div>

      <SelectedDeposit selectedPaymentMethod={selectedPaymentMethod} setSelectedPaymentMethod={setSelectedPaymentMethod} data-sentry-element="SelectedDeposit" data-sentry-source-file="DepositMethods.tsx" />
      {isMobile ? <>
          <MobileDepositAmountHeader totalAmount={amountToSend} />
          <MobileDepositNumberPad value={amountToSend} onValueChange={handleNumPadChange} setAmountToSend={setAmountToSend} />
        </> : <DepositAmount onValueChange={handleNumPadChange} totalAmount={amountToSend} setAmountToSend={setAmountToSend} />}

      {/* <DialogOrModal
        dialogClassName={'p-0 w-[480px]'}
        isOpen={openMoonPay || openOnramper}
        onClose={handleClick}
       >
        <div
          onClick={() => {
            setOpenMoonPay(false);
            setOpenOnramper(false);
          }}
          className='text-[14px] ml-4 mt-4 mb-2 flex items-center bg-genius-blue rounded-full h-[31px] w-[74px]'
        >
          <IoIosArrowBack
            className={`ml-2 mr-2 w-[16px] text-genius-cream`}
            width={20}
            height={18}
          />{' '}
          <p>Back</p>
        </div>
        {openMoonPay && <MoonpayDeposit amount={amountToSend} />}
        {/* {openOnramper && (
          <OnramperDeposit amount={amountToSend} paymentMethod={selectedPaymentMethod} />
        )} */}
      {/* </DialogOrModal> */}

      <div className='px-4'>
        <Button onClick={async () => {
        await handleClick();
      }} disabled={amountToSend === '0' || !amountToSend || parseFloat(amountToSend) < 30 || quoteLoading && utilizedProvider == 'Coinbase' || moonpayLoading && utilizedProvider == 'Moonpay'} className='h-[56px] text-[14px] rounded-full bg-genius-pink md:hover:bg-genius-pink w-full mt-0 lg:mt-12' data-sentry-element="Button" data-sentry-source-file="DepositMethods.tsx">
          {quoteLoading && utilizedProvider == 'Coinbase' || moonpayLoading && utilizedProvider == 'Moonpay' ? <>
              <Icons.spinner className='animate-spin w-6 h-6 mr-2 text-genius-blue' />
            </> : amountToSend === '0' || !amountToSend || parseFloat(amountToSend) < 30 ? 'Minimum deposit is $30' : 'Next'}
        </Button>
      </div>
    </>;
}